/* tslint:disable */
/* eslint-disable */
/**
 * Customer Journey Endpoints
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface DocumentFeatureValuesResult
 */
export interface DocumentFeatureValuesResult {
	/**
	 *
	 * @type {number}
	 * @memberof DocumentFeatureValuesResult
	 */
	mileage?: number | null;
	/**
	 *
	 * @type {boolean}
	 * @memberof DocumentFeatureValuesResult
	 */
	uploadAttemptsLimitExceeded?: boolean | null;
	/**
	 *
	 * @type {string}
	 * @memberof DocumentFeatureValuesResult
	 */
	vin?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof DocumentFeatureValuesResult
	 */
	numberPlate?: string | null;
	/**
	 *
	 * @type {boolean}
	 * @memberof DocumentFeatureValuesResult
	 */
	additionalDamageDetected?: boolean | null;
}

/**
 * Check if a given object implements the DocumentFeatureValuesResult interface.
 */
export function instanceOfDocumentFeatureValuesResult(
	value: object
): value is DocumentFeatureValuesResult {
	return true;
}

export function DocumentFeatureValuesResultFromJSON(json: any): DocumentFeatureValuesResult {
	return DocumentFeatureValuesResultFromJSONTyped(json, false);
}

export function DocumentFeatureValuesResultFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): DocumentFeatureValuesResult {
	if (json == null) {
		return json;
	}
	return {
		mileage: json['mileage'] == null ? undefined : json['mileage'],
		uploadAttemptsLimitExceeded:
			json['uploadAttemptsLimitExceeded'] == null ? undefined : json['uploadAttemptsLimitExceeded'],
		vin: json['vin'] == null ? undefined : json['vin'],
		numberPlate: json['numberPlate'] == null ? undefined : json['numberPlate'],
		additionalDamageDetected:
			json['additionalDamageDetected'] == null ? undefined : json['additionalDamageDetected'],
	};
}

export function DocumentFeatureValuesResultToJSON(json: any): DocumentFeatureValuesResult {
	return DocumentFeatureValuesResultToJSONTyped(json, false);
}

export function DocumentFeatureValuesResultToJSONTyped(
	value?: DocumentFeatureValuesResult | null,
	ignoreDiscriminator: boolean = false
): any {
	if (value == null) {
		return value;
	}

	return {
		mileage: value['mileage'],
		uploadAttemptsLimitExceeded: value['uploadAttemptsLimitExceeded'],
		vin: value['vin'],
		numberPlate: value['numberPlate'],
		additionalDamageDetected: value['additionalDamageDetected'],
	};
}
